export const RESOURCE = 'useraccount';
export const ACTIONS = { Get: '', Update: '' }